import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { AutoComplete } from 'primereact/autocomplete';

function AutoCompleteDropDown({ formik, service, field = 'descricao', ...rest }, ref) {
    const [options, setOptions] = useState([]);

    useImperativeHandle(ref, () => ({ setOptions }), [options]);

    return (
        <AutoComplete
            value={formik?.values?.[rest?.name]}
            suggestions={options}
            field={field}
            forceSelection
            completeMethod={async (res) => {
                if (typeof service === 'function') {
                    if (res?.query) {
                        const response = await service(res.query);
                        setOptions(response ?? []);
                    }
                }
            }}
            onChange={formik?.handleChange}
            {...rest}
        />
    );
}

export default forwardRef(AutoCompleteDropDown);
